////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const salesByArticleHistoryManager = {
	getSalesByArticleHistory: (filters = {}, queryParams = { page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' }) => ({
		type: ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY,
		payload: {
			filters,
			queryParams,
		},
	}),
	getSalesByArticleHistorySuccess: (data) => ({
		type: ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY_SUCCESS,
		payload: {
			data,
		},
	}),
	getSalesByArticleHistoryFailure: (error) => ({
		type: ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY_FAILURE,
		payload: {
			error,
		},
	}),
	resetSalesByArticleItems: () => ({
		type: ActionsTypes.RESET_SALES_BY_ARTICLE_ITEMS,
	}),
	setTransactionNumber: (transactionNumber) => ({
		type: ActionsTypes.SET_TRANSACTION_BY_ARTICLE_NUMBER,
		payload: {
			transactionNumber,
		},
	}),
	setPromotionNumber: (promotionNumber) => ({
		type: ActionsTypes.SET_PROMOTION_BY_ARTICLE_NUMBER,
		payload: {
			promotionNumber,
		},
	}),
}

export default salesByArticleHistoryManager
